// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var MediaCollectionName_Enum;
(function (MediaCollectionName_Enum) {
    MediaCollectionName_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    MediaCollectionName_Enum["TEST_COLLECTION"] = "TEST_COLLECTION";
    MediaCollectionName_Enum["BULK_EMAIL_ATTACHMENTS"] = "BULK_EMAIL_ATTACHMENTS";
    MediaCollectionName_Enum["BULK_EMAIL_TEMPLATE_THUMBNAILS"] = "BULK_EMAIL_TEMPLATE_THUMBNAILS";
    MediaCollectionName_Enum["BULK_EMAIL_CONTENT_THUMBNAILS"] = "BULK_EMAIL_CONTENT_THUMBNAILS";
    MediaCollectionName_Enum["TENDLC"] = "TENDLC";
})(MediaCollectionName_Enum || (MediaCollectionName_Enum = {}));
export var MediaCollectionName_Enum_index;
(function (MediaCollectionName_Enum_index) {
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["TEST_COLLECTION"] = 1] = "TEST_COLLECTION";
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["BULK_EMAIL_ATTACHMENTS"] = 2] = "BULK_EMAIL_ATTACHMENTS";
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["BULK_EMAIL_TEMPLATE_THUMBNAILS"] = 3] = "BULK_EMAIL_TEMPLATE_THUMBNAILS";
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["BULK_EMAIL_CONTENT_THUMBNAILS"] = 4] = "BULK_EMAIL_CONTENT_THUMBNAILS";
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["TENDLC"] = 5] = "TENDLC";
})(MediaCollectionName_Enum_index || (MediaCollectionName_Enum_index = {}));
/**
 * SecureMedia provides a place for products/services to store media assets (thumbnails, attachments, etc.) that should be _securely_ available. Media
 * assets uploaded to this service will be accessible to any user with access to the org and the media id. URLs generated by this service are signed
 * and will allow anybody with the link to access the media until the link expires.
 * The frontend should not typically need to interact directly with this service, except to upload media. See the note below on how other services
 * should manage media.
 * The signed URLs generated by this service are valid for a limited time, currently set to 24 hours.
 * This service does not provide a way to list media. The assumption is that media stored in this service will be referenced by id from _other_ services
 * that have their own mechanism for managing assets and permissions. Those services will request secure links to the media from this service, which can
 * then be returned to the frontend.
 */
export const SecureMedia = {
    /**
     * GetMedia returns a single media item from the specified collection.
     */
    GetMedia(fn, req) {
        try {
            fm.validateUrlParam(req["collectionName"], "collectionName");
            fm.validateUrlParam(req["mediaId"], "mediaId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/media/secure/v1/collections/${req["collectionName"]}/media/${req["mediaId"]}?${fm.renderURLSearchParams(req, ["collectionName", "mediaId"])}`, { method: "GET" });
    },
    /**
     * DeleteMedia will delete the specified media item. This is a destructive operation that cannot be undone.
     */
    DeleteMedia(fn, req) {
        try {
            fm.validateUrlParam(req["collectionName"], "collectionName");
            fm.validateUrlParam(req["mediaId"], "mediaId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/media/secure/v1/collections/${req["collectionName"]}/media/${req["mediaId"]}?${fm.renderURLSearchParams(req, ["collectionName", "mediaId"])}`, { method: "DELETE" });
    },
};
